const { KEYBOARD_KEYS } = require('../a11yHelper');

/**
 * Gets redirect URL from server and redirects to it
 * @param {string} url - URL to send request to
 * @param {Object} data - Request data to send with request
 */
const redirect = (url, data) => {
    $.ajax({
        url,
        type: 'get',
        dataType: 'json',
        data,
        success: (response) => {
            if (response && response.redirectUrl) {
                window.location.href = response.redirectUrl;
            }
        },
    });
};

module.exports = () => {
    // header country selector
    $('.country-selector a').on('click', (e) => {
        e.preventDefault();

        let action = $('.page').data('action');
        let queryString = $('.page').data('querystring');

        const $target = $(e.currentTarget);
        const url = $('.country-selector').data('url');
        const code = $target.data('locale');
        const CurrencyCode = $target.data('currencycode');
        const trainerId = $('.page').data('trainerid');
        const $pageDesignerPage = $('.page-designer-reference');
        const pageDesignerPageId = $pageDesignerPage.find('div[id]').attr('id');

        if (!action && !queryString && pageDesignerPageId) {
            action = 'Page-Show';
            queryString = `cid=${pageDesignerPageId}`;
        }

        redirect(url, {
            code,
            queryString,
            CurrencyCode,
            action,
            trainerId,
        });
    });

    // Footer country selector with new classes to avoid conflicts with other language selectors
    const $dropdown = $('.js-dropdown-footer');
    const $toggle = $dropdown.find('.dropdown-toggle-footer');
    const $menu = $dropdown.find('.dropdown-menu-footer');
    const $items = $menu.find('a');

    const closeDropdown = () => {
        $menu.removeClass('show');
        $toggle.attr('aria-expanded', 'false');
    };

    const openDropdown = () => {
        $menu.addClass('show');
        $toggle.attr('aria-expanded', 'true');
    };

    // Handle click to open/close the dropdown
    $toggle.on('click', (e) => {
        e.preventDefault();
        const isExpanded = $menu.hasClass('show');
        if (isExpanded) {
            closeDropdown();
        } else {
            openDropdown();
            $items.first().focus();
        }
    });

    // Handle keyboard navigation on toggle
    $toggle.on('keydown', (e) => {
        if (['ArrowDown', 'Enter', ' '].includes(e.key)) {
            e.preventDefault();
            openDropdown();
            $items.first().focus();
        } else if (e.key === KEYBOARD_KEYS.ESC) {
            e.preventDefault();
            closeDropdown();
        }
    });

    // Keyboard navigation in menu
    $items.on('keydown', function handleKeydown(e) {
        const $current = $(this);

        if (e.key === KEYBOARD_KEYS.ARROW_DOWN) {
            e.preventDefault();
            const $next = $current.closest('li').next().find('a');
            if ($next.length) $next.focus();
        } else if (e.key === KEYBOARD_KEYS.ARROW_UP) {
            e.preventDefault();
            const $prev = $current.closest('li').prev().find('a');
            if ($prev.length) $prev.focus();
            else $toggle.focus(); // Focus back to toggle if at top
        } else if (e.key === KEYBOARD_KEYS.ENTER) {
            closeDropdown();
            $(this).trigger('click');
        } else if (e.key === KEYBOARD_KEYS.ESC) {
            e.preventDefault();
            closeDropdown();
            $toggle.focus();
        }
    });

    // Handle country selection via click
    $items.on('click', (e) => {
        e.preventDefault();

        let action = $('.page').data('action');
        let queryString = $('.page').data('querystring');
        const $target = $(e.currentTarget);
        const url = $dropdown.data('url');
        const code = $target.data('locale');
        const CurrencyCode = $target.data('currencycode');
        const trainerId = $('.page').data('trainerid');
        const $pageDesignerPage = $('.page-designer-reference');
        const pageDesignerPageId = $pageDesignerPage.find('div[id]').attr('id');

        if (!action && !queryString && pageDesignerPageId) {
            action = 'Page-Show';
            queryString = `cid=${pageDesignerPageId}`;
        }

        redirect(url, {
            code,
            queryString,
            CurrencyCode,
            action,
            trainerId,
        });
    });

    // Handle select dropdowns (if used in mobile)
    $('.js-mobile-language-selector, .js-country-selector').on('change', (e) => {
        e.preventDefault();

        let action = $('.page').data('action');
        let queryString = $('.page').data('querystring');
        const $target = $(e.currentTarget);
        const url = $target.data('url');
        const code = $target.find(':selected').data('locale');
        const CurrencyCode = $target.find(':selected').data('currencycode');
        const trainerId = $('.page').data('trainerid');
        const $pageDesignerPage = $('.page-designer-reference');
        const pageDesignerPageId = $pageDesignerPage.find('div[id]').attr('id');

        if (!action && !queryString && pageDesignerPageId) {
            action = 'Page-Show';
            queryString = `cid=${pageDesignerPageId}`;
        }

        redirect(url, {
            code,
            queryString,
            CurrencyCode,
            action,
            trainerId,
        });
    });

    // Handle Cookiebot consent for default country storage
    window.addEventListener('CookiebotOnAccept', () => {
        if (!window.Cookiebot.consented) return;

        const $selectedOption = $('.js-country-selector li.selected a');
        if (!$selectedOption.length) return;

        const defaultCountry = {
            id: `${$selectedOption.data('language')}_${$selectedOption.data('country-code')}`,
            country: $selectedOption.data('country-code'),
            currencyCode: $selectedOption.data('currency-code'),
        };
        const defaultCountryJSON = JSON.stringify(defaultCountry).replace(/"/g, '\\"');
        document.cookie = `defaultCountry="${defaultCountryJSON}"; expires=Session; path=/`;
    });

    // Close dropdown on click outside only in the pages you the dropdown language selector
    $(document).on('click', (e) => {
        if ($dropdown) {
            if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
                closeDropdown();
            }
        }
    });

    $dropdown.on('keydown', '.dropdown-item', function handleDropdownItemKeydown(e) {
        const $menuItems = $dropdown.find('.dropdown-item');
        const currentIndex = $menuItems.index(this);

        if (e.key === KEYBOARD_KEYS.ARROW_DOWN) {
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % $menuItems.length;
            $menuItems.eq(nextIndex).focus();
        } else if (e.key === KEYBOARD_KEYS.ARROW_UP) {
            e.preventDefault();
            const prevIndex = (currentIndex - 1 + $menuItems.length) % $menuItems.length;
            $menuItems.eq(prevIndex).focus();
            // Close dropdown on Enter or Space
        } else if (e.key === KEYBOARD_KEYS.ENTER || e.key === KEYBOARD_KEYS.SPACE) {
            e.preventDefault();
            closeDropdown();
            $toggle.focus(); // return focus to toggle
        }
    });
};
